import { PageLocatorMap } from '../types/PageLocatorMap';

export const dashboardApplicationPage = {
  alert: {
    retryFailedSubmission:
      'dashboard-application-page.alert.retry-failed-submission',
  },
  header: {
    backButton: 'dashboard-application-page.header.back-button',
    drawerButton: 'dashboard-application-page.header.drawer-button',
    root: 'dashboard-application-page.header.root',
  },
  main: {
    bannerSectionRoot: 'dashboard-application-page.main.banner-section-root',
    contactSectionEmployeeEmail:
      'dashboard-application-page.main.contact-section-employee-email',
    contactSectionEmployeeName:
      'dashboard-application-page.main.contact-section-employee-name',
    contactSectionEmployeePhone:
      'dashboard-application-page.main.contact-section-employee-phone',
    contactSectionH4: 'dashboard-application-page.main.contact-section-h4',
    contactSectionRoot: 'dashboard-application-page.main.contact-section-root',
    progressSectionEmptyText:
      'dashboard-application-page.main.progress-section-empty-text',
    progressSectionH3: 'dashboard-application-page.main.progress-section-h3',
    progressSectionRoot:
      'dashboard-application-page.main.progress-section-root',
    progressSectionStepper:
      'dashboard-application-page.main.progress-section-stepper',
    progressSectionViewAllButton:
      'dashboard-application-page.main.progress-section-view-all-button',
    root: 'dashboard-application-page.main.root',
    taskSectionActionButton:
      'dashboard-application-page.main.task-section-action-button',
    taskSectionDescription:
      'dashboard-application-page.main.task-section-description',
    taskSectionH1: 'dashboard-application-page.main.task-section-h1',
    taskSectionH2: 'dashboard-application-page.main.task-section-h2',
    taskSectionRoot: 'dashboard-application-page.main.task-section-root',
    vehicleImage: 'dashboard-application-page.main.vehicle-image',
  },
} as const satisfies PageLocatorMap;
